export const heading = "h1801d9h";
export const subHeading = "s1v1ur6a";
export const inputContainer = "i1yskyeg";
export const button = "bvu3vqb";

require("./style.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");